import { App } from "antd";
import { useEffect } from "react";

// 定义一个空的 messageApi 对象
export const scaMessage = {};

/**
 * 这是一个辅助的 React 组件，它什么都不渲染，
 * 唯一的目的就是调用 useApp hook 来获取 antd 的静态方法实例，
 * 并将它们赋值给我们导出的 message 对象。
 */
export const AntdStatic = () => {
    const { message: messageInstance } = App.useApp();

    useEffect(() => {
        localStorage.removeItem("selectedDeviceData");
    }, []);

    // 将获取到的实例动态添加到导出的 message 对象上
    // 这样其他地方导入的 message 对象就有了 success, error 等方法
    Object.assign(scaMessage, messageInstance);

    return null; // 此组件不需要渲染任何内容
};
